import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CompensationProposal from './Pages/CompensationProposal'
import Dashboard from './Pages/Dashboard'
import ImportManualDetailsOne from './Pages/ImportManualDetailsOne'
import CompensationNewProposalForm from './Pages/CompensationNewProposalForm'
import ProjectApprovalPendingList from './Pages/ProjectApprovalPendingList'
import CompensationProposalDetails from './Pages/CompensationProposalDetails'
import RoadDetailsForm from './Components/RoadDetailsForm'
// import UserCreation from './Pages/UserCreation'
// import Test from './Pages/Test'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CompensationBeneficiaryUpdate from "./Components/CompensationBeneficiaryUpdate";
import SubmitProposal from "./Components/SubmitProposal";
import CompensationProposalDetail from "./Pages/CompensationProposalDetail";


function App() {
  return (
    <>
    <ToastContainer />
    <Routes> 
      {/* <Route path='/' element={<Login />} /> */}
      <Route path='/' element={<Dashboard />} />
      <Route path='/CompensationProposal' element={<CompensationProposal />} />
      <Route path='/CompensationNewProposalForm' element={<CompensationNewProposalForm />} />
      <Route path='/RoadDetailsForm' element={<RoadDetailsForm />} />
      <Route path='/ImportManualDetailsOne' element={<ImportManualDetailsOne />} />
      <Route path='/ProjectApprovalPendingList' element={<ProjectApprovalPendingList />} />
      {/* <Route path='/CompensationProposalDetails' element={<CompensationProposalDetails />} /> */}
      <Route path='/CompensationProposalDetail' element={<CompensationProposalDetail />} />
      <Route path='/CompensationBeneficiaryUpdate' element={<CompensationBeneficiaryUpdate />} />
      <Route path='/SubmitProposal' element={<SubmitProposal />} />

      {/* <Route path='/Test' element={<Test />} /> */}
    </Routes>

    </>
 
  );
}

export default App;
